/**
 * Source type values corresponding to the source field in location payloads.
 */
export const SOURCE_SMS = 'sms';
export const SOURCE_RCS = 'rcs';
export const SOURCE_MMS = 'mms';
export const SOURCE_CALL = 'call';
export const SOURCE_TCAPI = 'tcapi';
export const SOURCE_ADMIN_SMS = 'admin_sms';
export const SOURCE_OUTBOUND_SMS = 'outbound_sms';
export const SOURCE_CITIZEN_LOCATION = 'citizen_location';
export const SOURCE_INTERAGENCY_CHAT = 'interagency_chat';

export type LocationSources =
  | typeof SOURCE_SMS
  | typeof SOURCE_RCS
  | typeof SOURCE_MMS
  | typeof SOURCE_CALL
  | typeof SOURCE_TCAPI
  | typeof SOURCE_ADMIN_SMS
  | typeof SOURCE_OUTBOUND_SMS
  | typeof SOURCE_CITIZEN_LOCATION
  | typeof SOURCE_INTERAGENCY_CHAT;
